import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { resolveImg, onImgError } from "@/lib/images";

const LOGO_SRC = "/api/files/melograno/properties/0fb53515-1026-4c3f-b743-74a64b9e47f3.jpg";

export default function PublicFooter() {
  const { t } = useLang();
  return (
    <footer className="mt-16 md:mt-32 border-t border-[var(--mel-border)] bg-[var(--mel-surface)]" data-testid="public-footer">
      <div className="mel-container py-10 md:py-16 grid sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
        <div className="sm:col-span-2 md:col-span-2 max-w-md">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={resolveImg(LOGO_SRC)}
              onError={onImgError}
              alt="The apARTments"
              className="h-10 md:h-12 w-auto rounded-sm flex-shrink-0"
            />
            <div className="min-w-0">
              <div className="font-serif text-lg md:text-xl">Il Melograno</div>
              <div className="eyebrow truncate" style={{ fontSize: '0.6rem' }}>{t.header.brandSub}</div>
            </div>
          </div>
          <p className="text-sm text-[var(--mel-muted)] leading-relaxed">{t.footer.about}</p>
        </div>

        <div>
          <div className="eyebrow mb-3 md:mb-4">{t.footer.navigate}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[var(--mel-primary)]">{t.nav.home}</Link></li>
            <li><Link to="/proprieta" className="hover:text-[var(--mel-primary)]">{t.nav.properties}</Link></li>
            <li><Link to="/storia" className="hover:text-[var(--mel-primary)]">{t.nav.story}</Link></li>
            <li><Link to="/contatti" className="hover:text-[var(--mel-primary)]">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-3 md:mb-4">{t.footer.contact}</div>
          <ul className="space-y-3 text-sm text-[var(--mel-muted)]">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 flex-shrink-0" /> <span className="break-words">{t.contact.seatValue}</span></li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 flex-shrink-0" /> <a href="mailto:ionnisnc@gmail.com" className="break-all hover:text-[var(--mel-primary)]">ionnisnc@gmail.com</a></li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 flex-shrink-0" /> <a href="tel:+393495264881" className="hover:text-[var(--mel-primary)]">+39 349 5264881</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--mel-border)]">
        <div className="mel-container py-5 md:py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-[var(--mel-muted)]">
          <div>© {new Date().getFullYear()} {t.footer.copyright}</div>
          <Link to="/login" className="hover:text-[var(--mel-primary)]" data-testid="footer-staff-login">{t.footer.staffLogin}</Link>
        </div>
      </div>
    </footer>
  );
}
